import { domainLabel } from '@/features/common/useThematicDomains';
import type { Advisor } from '@/features/publicsite/types/registry/Advisor';
import type { DomainChip } from '@/features/publicsite/types/registry/DomainChip';

/**
 * An adviser's competence domains as the reader's language names them, for the chips on their card.
 *
 * Kept in the order the profile stored them rather than sorted: that order is the adviser's own
 * answer to what they advise on, and the endpoint preserves it deliberately (T243).
 *
 * The names come from the row. Until T243 a card could name a domain only by reading
 * CONSILIERI_DOMENII itself and joining, or by asking once per card — which is why the chips did
 * not exist. A retired domain is named too, so a card does not lose a domain the adviser still
 * holds; an id the nomenclature no longer has at all never reaches here, the endpoint skips it.
 *
 * No labels at all gives no chips, which is also what a backend older than T243 gives: the field
 * is read through `?? []` because this is a public page and a missing key must not blank it.
 */
export function advisorDomainChips(
  advisor: Pick<Advisor, 'competenceDomainLabels'>,
  language: string,
): DomainChip[] {
  return (advisor.competenceDomainLabels ?? []).map((domain) => ({
    id: domain.id,
    label: domainLabel(domain, language),
  }));
}
